import { render } from "./SignUpConfirm.vue?vue&type=template&id=43824b5c&scoped=true"
import script from "./SignUpConfirm.vue?vue&type=script&lang=js"
export * from "./SignUpConfirm.vue?vue&type=script&lang=js"

import "./SignUpConfirm.vue?vue&type=style&index=0&id=43824b5c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3957297443/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43824b5c"]])

export default __exports__